/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

/* eslint-disable no-unused-vars */
export enum TripType {
  ROUND_TRIP = 'ROUNDTRIP',
  ONE_WAY = 'ONEWAY',
}
/* eslint-enable no-unused-vars */

export type TripTypeSelectorProps = {
  tripType: TripType;
  onChange: (tripType: TripType) => void;
  autoSearch?: (tripType: TripType) => void;
  disabled?: boolean;
};
